// js-topMv-slik
jQuery(function ($) {
	$(".js-topMv-slik").slick({
		arrows: false,
		dots: false,
		autoplay: true,
		speed: 2000,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 20000 // 最初のスライドの秒数
	})
	.on("afterChange", function(event, slick, currentSlide) {
		switch (currentSlide){
			case 0:
				// 1枚目2週目以降の秒数
				$(this).slick("slickSetOption", "autoplaySpeed", 20000);
				break;
			// case 2:
			//   // 3枚目の秒数
			//   $(this).slick("slickSetOption", "autoplaySpeed", 500);
			//   break;
			default:
				// その他の秒数
				$(this).slick("slickSetOption", "autoplaySpeed", 1000);
				break;
		}
	});
});


function checkBreakPoint() {
	w = $(window).width();
	if (w <= 880) {
		$('.js-topTopics-slik-sp').not('.slick-initialized').slick({
			//スライドさせる
			arrows: true,
			dots: false,
			autoplay: true,
			autoplaySpeed: 4000,
			speed: 800,
			centerMode: true,
			// centerPadding: '20%',
			centerPadding: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: true,
			});
	} else {
		// PC向け
		$('.js-topTopics-slik-sp.slick-initialized').slick('unslick');
	}
}
// ウインドウがリサイズする度にチェック
$(window).resize(function(){
	checkBreakPoint();
});
// 初回チェック
checkBreakPoint();
